import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './DocumentSelector.module.css'

const DOCUMENTOS = [
  {
    value: '/api/core/interno/documento-csv/pending-invoices',
    text: 'Facturas pendientes'
  },
  {
    value: '/api/core/interno/documento-csv/pending-payments',
    text: 'Pagos pendientes'
  },
  {
    value: '/api/core/interno/documento-csv/pending-feedbacks',
    text: 'Leads modificados'
  },
  {
    value: '/api/core/interno/documento-csv/student-certificates',
    text: 'Listado certificados alumnos'
  },
  {
    value: '/api/core/interno/documento-csv/feedback-analysis',
    text: 'Análisis ROI',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/accounting-analysis',
    text: 'Análisis P&L',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/cashflow-analysis',
    text: 'Análisis Cashflow',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/churning-students',
    text: 'Bajas alumnos',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/product-analisis-english',
    text: 'Análisis Inglés',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/product-analisis-university',
    text: 'Análisis Universidad',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/bank-wires-analysis',
    text: 'Detalle Transferencias',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/student-level-checks',
    text: 'Verificación niveles alumno',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/incomplete-attendances',
    text: 'Asistencias incompletas',
    monthSelection: true
  },
  {
    value: '/api/core/interno/documento-csv/issued-invoices',
    text: 'Facturas emitidas',
    monthSelection: true
  }
]

const DocumentSelector = ({ className, name, label, value, onChange }) => {
  return (
    <FormControl className={`${className} ${css.main}`} variant='standard'>
      <InputLabel id={name}>{label}</InputLabel>
      <Select
        labelId={name}
        id={name}
        value={value}
        onChange={onChange}
        label={label}
      >
        {DOCUMENTOS.map(documento => (
          <MenuItem key={documento.text} value={documento}>
            {documento.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default DocumentSelector
